import { React, memo } from "react";
import "../../services/AxiosService";
import "./footer.scss";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import logoJunta from "../../../resources/img/logotipo-de-la-junta-de-extremadura-svg@2x.png"
import logoUE from "../../../resources/img/logotipo-union-europea.png"
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <div className="footer-container" role="contentinfo" aria-label="Pie" data-landmark-index="1">
        <div className="subfooter_1">
          <div className="imagenes">
            <div
              className="logoJunta px-2 cursorPointer"
              role="link"
              onClick={() => window.open("https://www.juntaex.es/")}
              title="Enlace junta de Extremadura"
              aria-label="Enlace para acceso a la página principal de la junta de Extremadura"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  window.open("https://www.juntaex.es/");
                }
              }}
            >
              <img src={logoJunta} alt="Logotipo de la Junta de Extremadura" />
            </div>

            <div className="logoUE px-2 cursorPointer" onClick={() => window.open("https://www.juntaex.es/temas/administracion-publica/fondos-europeos")}
              title="Enlace a fondos Europeos"
              aria-label="Enlace para acceso a la página de fondos Europeos de la junta de Extremadura"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  window.open("https://www.juntaex.es/temas/administracion-publica/fondos-europeos")
                }
              }}>
              <img src={logoUE} alt="" />
            </div>
          </div>
        </div>
        <div className="subfooter_2">
          <div className="copy">
            <p>2025 &copy; Junta de Extremadura. Todos los derechos reservados</p>
          </div>
          <div className="enlaces">
            <a
              href="https://outlook.office.com/mail/deeplink/compose?to=portalempleado@juntaex.es&subject=Consulta&body=Hola,%20tengo%20una%20pregunta."
              target="_blank"
              rel="noopener noreferrer"
              title="Enviar correo electrónico"
              aria-label="Enviar correo electrónico a portalempleado@juntaex.es"
            >
              Contáctanos
            </a><span className="separadorFooter" >|</span>
            <Link title="Accesibilidad" aria-label="Accesibilidad" role="link" to="/accesibilidad">Accesibilidad</Link><span className="separadorFooter" >|</span>
            <Link title="Aviso Legal" aria-label="Aviso Legal" role="link" to="/avisoLegal">Aviso Legal</Link><span className="separadorFooter">|</span>
            <Link title="Mapa Web" aria-label="Mapa Web" role="link" to="/mapaWeb">Mapa Web</Link>
            {/*<Link to="">Protección de datos</Link><span className="separadorFooter">|</span>
            <Link to="">Política de cookies</Link><span className="separadorFooter">|</span>
            <Link to="">Política de privacidad</Link>*/}
          </div>
          <div className="redes">

          </div>
        </div>

      </div>
    </>
  );
};

export default memo(Footer);
